import React from "react";

const Mute = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 28 30"
    {...props}
  >
    <path
      d="M19.37 16.125A6.001 6.001 0 0 0 20 13.5V6A6 6 0 0 0 8.12 4.875l11.25 11.25ZM24.5 13.5a1.5 1.5 0 0 0-3 0 7.29 7.29 0 0 1-1.035 3.72l2.205 2.28a10.5 10.5 0 0 0 1.83-6Zm-10.5 6h.24L8 13.245v.255a6 6 0 0 0 6 6Zm13.065 6.435-24-24a1.506 1.506 0 1 0-2.13 2.13l24 24a1.5 1.5 0 0 0 2.13 0 1.498 1.498 0 0 0 0-2.13Z
      M 18.5 27 h -3 v -3.12 c 0.849 -0.118 1.68 -0.34 2.475 -0.66 l -2.4 -2.4 A 6.855 6.855 0 0 1 14 21 a 7.5 7.5 0 0 1 -7.5 -7.5 a 1.5 1.5 0 0 0 -3 0 a 10.5 10.5 0 0 0 9 10.38 V 27 h -3 a 1.5 1.5 0 1 0 0 3 h 9 a 1.5 1.5 0 1 0 0 -3 Z"
      fill="currentColor"
    />

  </svg>
);
export default Mute;
